document.addEventListener('alpine:init', () => {
  Alpine.data('postFilter', (filterId = 'filter') => ({
    activeCategory: 'all',
    searchQuery: '',
    searchOpen: false,
    posts: [],
    allPosts: [],
    
    // Animation durations (in milliseconds)
    transitionDuration: 250, // Should match CSS transition duration
    displayDelay: 10, // Small delay for display change before transition
    
    init() {
      // Get the filter element and posts container
      this.filterEl = document.querySelector(`[data-filter-id="${filterId}"]`);
      this.postsContainer = document.querySelector(`[data-posts-container="${filterId}"]`);
      
      if (!this.filterEl || !this.postsContainer) return;
      
      // Store all posts for filtering
      this.getAllPosts();
      
      // Add event listeners to filter buttons
      this.setupFilterButtons();
      
      // Setup search functionality
      this.setupSearch();
    },
    
    getAllPosts() {
      const grid = this.postsContainer.querySelector('[data-posts-grid]');
      if (grid) {
        this.allPosts = Array.from(grid.children);
        this.posts = [...this.allPosts];
      }
    },
    
    setupFilterButtons() {
      const buttons = this.filterEl.querySelectorAll('.filter__item');
      
      buttons.forEach(button => {
        button.addEventListener('click', (e) => {
          const category = e.currentTarget.dataset.category;
          this.filterByCategory(category);
        });
      });
    },
    
    setupSearch() {
      const searchBtn = this.filterEl.querySelector('.filter__search-btn');
      const searchField = this.filterEl.querySelector('.filter__search-field');
      const searchInput = this.filterEl.querySelector('[data-search-input]');
      
      if (searchBtn && searchField) {
        searchBtn.addEventListener('click', () => {
          this.searchOpen = !this.searchOpen;
          searchField.classList.toggle('active', this.searchOpen);
          
          if (this.searchOpen && searchInput) {
            searchInput.focus();
          }
        });
      }
      
      if (searchInput) {
        searchInput.addEventListener('input', (e) => {
          this.searchQuery = e.target.value;
          
          // Hide featured post when searching
          const featuredSection = document.querySelector('.blog-index__featured');
          if (featuredSection) {
            if (this.searchQuery) {
              featuredSection.classList.add('blog-index__featured--hidden');
              setTimeout(() => {
                if (featuredSection.classList.contains('blog-index__featured--hidden')) {
                  featuredSection.classList.add('blog-index__featured--removed');
                }
              }, this.transitionDuration);
            } else if (this.activeCategory === 'all') {
              featuredSection.classList.remove('blog-index__featured--removed');
              setTimeout(() => {
                featuredSection.classList.remove('blog-index__featured--hidden');
              }, this.displayDelay);
            }
          }
          
          this.filterPosts();
        });
      }
    },
    
    filterByCategory(category) {
      this.activeCategory = category;
      
      // Update active button state
      const buttons = this.filterEl.querySelectorAll('.filter__item');
      buttons.forEach(button => {
        button.classList.toggle('filter__item--active', button.dataset.category === category);
      });
      
      // Show/hide featured post based on filter
      this.toggleFeaturedPost(category);
      
      this.filterPosts();
    },
    
    toggleFeaturedPost(category) {
      const featuredSection = document.querySelector('.blog-index__featured');
      if (featuredSection) {
        if (category === 'all') {
          // Show featured post
          featuredSection.classList.remove('blog-index__featured--removed');
          // Small delay to allow display change before transition
          setTimeout(() => {
            featuredSection.classList.remove('blog-index__featured--hidden');
          }, this.displayDelay);
        } else {
          // Hide featured post
          featuredSection.classList.add('blog-index__featured--hidden');
          // Add display none after transition completes
          setTimeout(() => {
            if (featuredSection.classList.contains('blog-index__featured--hidden')) {
              featuredSection.classList.add('blog-index__featured--removed');
            }
          }, this.transitionDuration);
        }
      }
    },
    
    filterPosts() {
      const grid = this.postsContainer.querySelector('[data-posts-grid]');
      if (!grid) return;
      
      // Clear current posts
      grid.innerHTML = '';
      
      // Filter posts
      let filteredPosts = [...this.allPosts];
      
      // Category filter
      if (this.activeCategory !== 'all') {
        filteredPosts = filteredPosts.filter(post => {
          // Check if post has the category data attribute
          const postCategories = post.dataset.categories;
          if (postCategories) {
            const categoriesArray = postCategories.split(',');
            return categoriesArray.includes(this.activeCategory);
          }
          return false;
        });
      }
      
      // Search filter
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        filteredPosts = filteredPosts.filter(post => {
          const content = post.textContent.toLowerCase();
          return content.includes(query);
        });
      }
      
      // Append filtered posts
      if (filteredPosts.length > 0) {
        filteredPosts.forEach(post => {
          grid.appendChild(post);
        });
      } else {
        // Show no results message
        const noResults = document.createElement('div');
        noResults.className = 'blog-index__no-results';
        noResults.textContent = 'No posts found matching your criteria.';
        grid.appendChild(noResults);
      }
    }
  }));
});

// Initialize filter on each filter component
document.addEventListener('DOMContentLoaded', () => {
  const filters = document.querySelectorAll('[data-filter-id]');
  filters.forEach(filter => {
    const filterId = filter.dataset.filterId;
    // Initialize Alpine component
    Alpine.initTree(filter.closest('section'));
  });
  
  // Handle case studies form-based filters (auto-submit on change)
  const caseStudiesForm = document.querySelector('.case-studies-filter');
  if (caseStudiesForm) {
    const selects = caseStudiesForm.querySelectorAll('select');
    selects.forEach(select => {
      select.addEventListener('change', function() {
        // Auto-submit the form when any select changes
        caseStudiesForm.submit();
      });
    });
  }
});